/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloTiposMovimientos from 'Infotrack@Modelos/smartStock/tiposMovimientos';
import ITiposMovimientos from 'Infotrack@Modelos/smartStock/tiposMovimientos/entidades/tiposMovimientos';

export default class ControladorModeloTiposMovimientos {
    private modeloTiposMovimientos: ModeloTiposMovimientos;
    constructor() {
        this.modeloTiposMovimientos = new ModeloTiposMovimientos();
    }

    public consultarTiposMovimientos() {
        return this.modeloTiposMovimientos.consultarTiposMovimientos().then(({ data: { Entidades } }) => Entidades);
    }

    public async crearTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        await this.modeloTiposMovimientos.crearTiposMovimientos(tiposMovimientos);
    }

    public async editarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        await this.modeloTiposMovimientos.editarTiposMovimientos(tiposMovimientos);
    }
    public async eliminarTiposMovimientos(tiposMovimientos: ITiposMovimientos) {
        await this.modeloTiposMovimientos.eliminarTiposMovimientos(tiposMovimientos);
    }

    public validarEntidad(tiposMovimientos: ITiposMovimientos): boolean {
        if (tiposMovimientos.TipoMovimientoDescripcion === '') {
            notificacionGlobal('Por favor ingrese todos los campos requeridos (*)', 6000, 'warning', true);
            return false;
        }
        return true;
    }
}
